<template>
  <b-row class="block__profile-notifications" >

    <!-- ENTETE -->
    <div class="mobile">
      <div class="link">
        <button class="bt btn-back" @click="goBack()">
            <font-awesome-icon :icon="['far', 'angle-left']"/>
        </button>
        <h3>{{general.profileTitleNotifications}}</h3>
      </div>
      <div class="sep"></div>
    </div>
    <!-- ENTETE -->

    <!-- CONTENT -->
    <div class="scrollable col">
      <b-list-group>
        <b-list-group-item v-for="(item,index) in items" :key="index">
          <PuSkeleton :loading="isLoading" :count="1" width='100%' height='2rem'>    
              {{item.name}}
              <div class="wrapper-button">
                <ion-toggle :checked="item.checked ? true : false"></ion-toggle>
              </div>
          </PuSkeleton>
        </b-list-group-item>
      </b-list-group> 
    </div>
    <!-- CONTENT -->


  </b-row>
</template>




<script>
import { mapGetters } from 'vuex'


export default {
  name:"ProfileNotifications",
    components:{
    }, 
    computed: {
      ...mapGetters([
        'getGeneral',
        'getInitial'
      ])
    },
    data () {
      return {
        general:"",
        isLoading:true,
        items:[],
      }
    },
    created (){
      this.general = this.getGeneral;
      this.items = this.general.profileNotifications;
    setTimeout(() => {
        this.isLoading = false;
      },2000)         
    },    
    methods : {
      goBack() {
        this.$router.push({name: "profileHome"});  
      },       
    }
};
</script>
